import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CampaignStatus } from "entities/domain/campaign";
import { ConversationChannel } from "entities/domain/conversations/conversation-domain";

export interface DeleteCampaignPayload {
  id: string;
}

export interface PauseCampaignPayload {
  id: string;
}

export interface ResumeCampaignPayload {
  id: string;
}

export interface CancelCampaignPayload {
  id: string;
}

export interface GetCampaignCustomersPayload {
  id: string;
}

export interface CreateCampaignPayload {
  name: string;
  merchantId: number;
  status: CampaignStatus;
  audienceId: string;
  templateName: string | null;
  messageBody: string | null;
  sentAt: string | null;
  channel: ConversationChannel;
  scheduledAt: string | null;
  scheduledFor: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  file: File | null;
  mediaType: string | null;
  mediaUrl: string | null;
  idempotencyKey: string;
  // Omitted/undefined = the platform default; only sent when chosen.
  operationsReservePercent?: number | null;
}

export interface EditCampaignPayload {
  id: string;
  name: string;
  merchantId: number;
  status: CampaignStatus;
  channel: ConversationChannel;
  audienceId: string;
  templateName: string | null;
  messageBody: string | null;
  sentAt: string | null;
  scheduledAt: string | null;
  scheduledFor: string | null;
  createdAt: string | null;
  updatedAt: string | null;
  mediaUrl: string | null;
  mediaType: string | null;
  file: File | null;
  // undefined = leave the campaign's reserve as is; null = reset to the default.
  operationsReservePercent?: number | null;
}

// but they're no longer used in Redux reducers

export enum CampaignCategory {
  DraftScheduled = "draft_and_scheduled",
  Done = "done",
}

interface CampaignsState {
  activeCampaignCategory: CampaignCategory | undefined;
}
const initialState: CampaignsState = {
  activeCampaignCategory: CampaignCategory.Done,
};

const campaignsSlice = createSlice({
  name: "campaigns",
  initialState,
  reducers: {
    setActiveCampaignCategory: (
      state,
      action: PayloadAction<CampaignCategory | undefined>
    ) => {
      state.activeCampaignCategory = action.payload;
    },
    resetStore: (state) => {
      state.activeCampaignCategory = undefined;
    },
  },
});

export const { setActiveCampaignCategory, resetStore } = campaignsSlice.actions;
export const campaignsSliceActions = campaignsSlice.actions;
export default campaignsSlice.reducer;
